module.exports = angular.module('msi.layout.logged-out', []).name;

angular.module(module.exports)
  .config(require('./states'));
